import ButtonFactory from "@components/Button/ButtonFactory";
import { ButtonType } from "@components/Button/utils/types";
import { useGTMDispatch } from "@elgorditosalsero/react-gtm-hook";
import { cn } from "@util/helpers";

type LearnMoreProps = {
  /** This is the classname of the component. */
  className?: string;
  /** This is the function to set the state of the modal. */
  setIsShown: React.Dispatch<React.SetStateAction<boolean>>;
  /** The GA variant for the LearnMore component. */
  gaVariant?: string;
};

/**
 * The learn more button to be displayed.
 * @figma https://www.figma.com/design/9RrH1KYIUOZk6rvgzlBBKX/WEB-BAU-2026?node-id=19023-42986&t=tpbpx7fCaGouWZGL-0
 */
const LearnMore = ({
  className,
  setIsShown,
  gaVariant,
}: LearnMoreProps): React.ReactElement => {
  const sendDataToGTM = useGTMDispatch();

  const handleClick = () => {
    setIsShown(true);

    sendDataToGTM({
      event: "custom_event",
      eventCategory: "deeperdive",
      eventAction: "click",
      eventLabel: "learn more",
      abVariant: gaVariant,
      abVariant_user: gaVariant,
    });
  };

  return (
    <ButtonFactory
      buttonType={ButtonType.Secondary}
      text="Learn more"
      className={cn("border-0 p-0 text-xs", className)}
      onClick={handleClick}
    />
  );
};

export default LearnMore;
